<template>
  <div>
    <el-menu class="navbar" mode="horizontal">
      <hamburger
        class="hamburger-container"
        :toggleClick="toggleSideBar"
        :isActive="sidebar.opened"
        >
      </hamburger>
      <breadcrumb class="breadcrumb-container"></breadcrumb>
      <div class="right-menu">
        <lang-select class="international right-menu-item"></lang-select>
        <el-dropdown class="avatar-container right-menu-item" trigger="click">
          <el-button size="mini" class="avatar-wrapper">
            <img class="user-avatar" src="//cdn.myfunnow.com/admin/favicon/favicon.png">
            <span class="user-name">{{ uname }}</span>
            <i class="el-icon-caret-bottom"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <router-link to="/">
              <el-dropdown-item>
                {{ $t('navbar.home') }}
              </el-dropdown-item>
            </router-link>
            <el-dropdown-item @click.native="showEditAuthToken">
              {{ $t('navbar.updatePassword') }}
            </el-dropdown-item>
            <el-dropdown-item divided @click.native="logout">
              {{ $t('navbar.logOut') }}
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </el-menu>
    <el-dialog
      :title="$t('api.user.editPassDialog')"
      :visible.sync="editPassVis"
      >
      <el-form
        label-position="top"
        :model="passData"
        ref="passData"
        >
        <password-input
          :needOriginPass="true"
          :formRef="passDataRef"
          :passData="passData"
          >
        </password-input>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="editPassVis = false">{{ $t('api.cancelBtn') }}</el-button>
        <el-button type="primary"
          :loading="submitLoading"
          @click="updatePass"
          >
          {{ $t('api.saveBtn') }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { MessageBox } from 'element-ui'
import Breadcrumb from '@/components/Breadcrumb'
import Hamburger from '@/components/Hamburger'
import LangSelect from '@/components/LangSelect'
import { changePassword } from '@/api/auth/password'

export default {
  components: {
    Breadcrumb,
    Hamburger,
    LangSelect
  },
  data () {
    return {
      submitLoading: false,
      passData: {
        ori_pass: '',
        auth_token: '',
        auth_token_c: ''
      },
      passDataRef: {},
      editPassVis: false
    }
  },
  mounted () {
    this.passDataRef = this.$refs.passData
  },
  computed: {
    sidebar () {
      return this.$store.state.app.sidebar
    },
    device () {
      return this.$store.state.app.device
    },
    uname () {
      return (this.device === 'mobile') ? '' : this.$store.state.user.username
    }
  },
  methods: {
    toggleSideBar () {
      this.$store.dispatch('toggleSideBar')
    },
    showEditAuthToken () {
      this.editPassVis = true
      this.passData.auth_type = 0
      this.passData.ori_pass = ''
      this.passData.auth_token = ''
      this.passData.auth_token_c = ''
      this.$nextTick(() => {
        this.$refs.passData.clearValidate()
      })
    },
    updatePass () {
      this.$refs.passData.validate(valid => {
        if (!valid) {
          return false
        }
        this.submitLoading = true
        var updPass = {
          old_pwd: this.passData.ori_pass,
          new_pwd: this.passData.auth_token
        }
        changePassword(updPass).then(response => {
          this.editPassVis = false
          this.$message({
            message: this.$t('api.user.editPassSuccess'),
            type: 'success',
            duration: 2000
          })
        }).catch(err => {
          console.log(err)
        }).then(() => {
          this.submitLoading = false
        })
      })
    },
    logout () {
      MessageBox.confirm(this.$t('logout.confirmMessage'),
        this.$t('logout.confirmTitle'), {
          confirmButtonText: this.$t('logout.confirmBtn'),
          cancelButtonText: this.$t('api.cancelBtn'),
          type: 'warning'
        }
      ).then(() => {
        this.$store.dispatch('LogOut').then(() => {
          location.href = '/login'
        })
      })
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.navbar {
  height: 50px;
  line-height: 50px;
  border-radius: 0px !important;
  .hamburger-container {
    line-height: 58px;
    height: 50px;
    float: left;
    padding: 0 10px;
  }
  .breadcrumb-container{
    float: left;
  }
  .right-menu {
    float: right;
    height: 100%;
    &:focus{
     outline: none;
    }
    .right-menu-item {
      display: inline-block;
      margin: 0 0 0 10px;
    }
    .international{
      vertical-align: middle;
    }
    .avatar-container {
      height: 50px;
      margin-right: 15px;
      .avatar-wrapper {
        cursor: pointer;
        position: relative;
        padding: 5px 12px;
        .user-avatar {
          width: 16px;
          height: 16px;
          margin-top: 2px;
          vertical-align: top;
        }
        .user-name {
          font-weight: 400;
          font-size: 14px;
          line-height: 20px;
        }
        .el-icon-caret-bottom {
          font-size: 12px;
        }
      }
    }
  }
}
.mobile {
  .user-name {
    visibility: hidden;
  }
}
</style>
